import { useFormContext } from 'react-hook-form'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@/view/components/ui/use-toast'
import { ForgotPasswordFormData } from '../components/types'
import { authService } from '@/app/services/authService'

interface UseForgotPasswordControllerProps {
  onCpfSet: (cpf: string) => void
}

export const useForgotPasswordController = ({
  onCpfSet,
}: UseForgotPasswordControllerProps) => {
  const methods = useFormContext<ForgotPasswordFormData>()
  const { toast } = useToast()
  const navigate = useNavigate()

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (cpf: string) => {
      return authService.forgotPassword({ cpf })
    },
  })

  const handleFormSubmit = async (data: ForgotPasswordFormData) => {
    try {
      const cpf = data.cpf.replace(/\D/g, '')

      await mutateAsync(cpf)

      onCpfSet(data.cpf)

      toast({
        title: 'Código enviado!',
        description: 'Verifique seu e-mail para o código de recuperação.',
      })

      navigate('/code-recovery')
    } catch (error) {
      toast({
        variant: 'destructive',
        title: 'Erro ao enviar código',
        description: 'Verifique o CPF informado e tente novamente.',
      })
    }
  }

  return {
    methods,
    isPending,
    handleFormSubmit,
  }
}
